import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  icon: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  content: {
    width: 500,
    mt: -2,
  },
  text: {
    color: "rgba(0, 0, 0, 0.87)",
    textAlign: "center",
  },
};

export default function DeleteRoleErrorDialog({
  showDialog,
  closeDialog,
}: any) {
  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete Role?</DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.icon}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.content}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.text}>
            Roles can’t be deleted if they are assigned to 1 or more user.
          </Typography>
          <Typography sx={styles.text}>
            Remove the role from all users and try again.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={closeDialog}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
